import {initH5pLoader} from "./custom/h5pLoader";
//import {stickyBox} from "../../node_modules/cronus-theme/default/global/js/stickyBox";

import {
    initCollectionFilters
} from "./collections/list";

function initStyledList() {
    document.querySelectorAll('ol.styled-list').forEach(ol => {
        const start = parseInt(ol.getAttribute('start'), 10) || 1;
        ol.style.setProperty('--start', start);
    });
}

function initDataControlValidation() {
    document.querySelectorAll('td.js-data-control').forEach(cell => {
        cell.addEventListener('blur', validateByControl);
    });
}

function initDataAnswerValidation() {
    document.querySelectorAll('td.js-data-answer').forEach(cell => {
        cell.addEventListener('blur', validateCell);
    });
}

function initIframeResizing() {
    window.addEventListener('message', event => {
        if (event.data?.type === 'setHeight') {
            document.querySelectorAll('iframe').forEach(iframe => {
                if (iframe.contentWindow === event.source) {
                    iframe.style.height = event.data.height + 'px';
                }
            });
        }
    });
}

function initEnterKeyTriggers() {
    const spans = document.querySelectorAll('.js-collectionFilter span[tabindex="0"]');
    spans.forEach(span => {
        span.addEventListener('keydown', function(event) {
            if (event.key === 'Enter' || event.keyCode === 13) {
                event.preventDefault();
                const target = this.querySelector('input, button, a');
                if (target) {
                    target.click();
                } else {
                    this.click();
                }
            }
        });
    });
}

function addTabindexToSpans() {
    const spans = document.querySelectorAll('.js-collectionFilter span');
    spans.forEach(span => {
        span.setAttribute('tabindex', '0');
    });
}

function validateByControl(event) {
    const cell = event.target;
    const text = cell.textContent.trim();
    const control = cell.dataset.control;              // z.B. "digits-5"
    const [type, lenStr] = control.split('-');
    const length = parseInt(lenStr, 10);
    let regex;
    switch (type) {
        case 'digits':
            regex = new RegExp(`^\\d{${length}}$`);
            break;
        case 'lowercase':
            regex = new RegExp(`^[a-z]{${length}}$`);
            break;
        case 'digitslowercaseuppercase':
            regex = new RegExp(
                `^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])[A-Za-z\\d]{${length}}$`
            );
            break;
        default:
            console.warn('Unbekannter control-Typ:', control);
            return;
    }
    const valid = regex.test(text);
    cell.classList.toggle('correct', valid);
    cell.classList.toggle('incorrect', !valid);
}

function validateCell(event) {
    const cell = event.target;
    const correct = cell.dataset.answer;
    const entered = cell.textContent.trim();
    if (entered === correct) {
        cell.classList.add('correct');
        cell.classList.remove('incorrect');
    } else {
        cell.classList.add('incorrect');
        cell.classList.remove('correct');
    }
}

/*function loadChapterfromHash(){
    const hash = window.location.hash;
    if(hash){
        const id = hash.substring(1);
        const el = document.getElementById(id);
        const el2 = document.querySelector("."+id);
        if(el && el2){
            document.querySelectorAll('.js-showChapter').forEach(el => {
                el.classList.remove('is-active');
            });
            document.querySelectorAll('.sowinrw__slidecontent').forEach(el => {
                el.classList.remove('is-active');
            });
            el.classList.add("is-active");
            el2.classList.add("is-active");
        }
    }
}*/

document.addEventListener('DOMContentLoaded', function() {
    addTabindexToSpans();
    initEnterKeyTriggers();
    initStyledList();
    initDataControlValidation();
    initDataAnswerValidation();
    initIframeResizing();
    //loadChapterfromHash();
    initH5pLoader();
    initCollectionFilters();
});

/*document.querySelectorAll('.js-showChapter').forEach(function(el) {
    el.addEventListener('click', function() {
        document.querySelectorAll('.js-showChapter').forEach(el => {
            el.classList.remove('is-active');
        });
        document.querySelectorAll('.sowinrw__slidecontent').forEach(el => {
            el.classList.remove('is-active');
        });
        el.classList.add("is-active");
        document.getElementById(el.getAttribute('data-id')).classList.add("is-active");
    });
});*/

/*const stickyHeaderArea = document.querySelector('.headerMain');
let offsetTopStickyBox = 80;
if (stickyHeaderArea) {
    offsetTopStickyBox += stickyHeaderArea.clientHeight;
}

for (let pinBox of document.querySelectorAll(".js-stickyBox")) {
    stickyBox(pinBox, {
        offsetTop: offsetTopStickyBox,
        minWidth: GLOBALS.gridBreakpoints.sm,
    });
}*/

/*document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('container');
    if (!container) {
        return;
    }
    function sendHeight() {
        const cRect = container.getBoundingClientRect();
        let minY = Infinity;
        let maxY = -Infinity;
        for (const child of container.children) {
            const style = getComputedStyle(child);
            const rect  = child.getBoundingClientRect();
            const mTop  = parseFloat(style.marginTop);
            const mBot  = parseFloat(style.marginBottom);
            const topInContainer    = rect.top    - cRect.top - mTop;
            const bottomInContainer = rect.bottom - cRect.top + mBot;
            minY = Math.min(minY, topInContainer);
            maxY = Math.max(maxY, bottomInContainer);
        }
        const height = (maxY === -Infinity)
            ? container.scrollHeight
            : maxY - Math.min(minY, 0);
        window.parent.postMessage(
            { type: 'setHeight', height: Math.ceil(height) },
            '*'
        );
    }
    window.addEventListener('load', sendHeight);
    window.addEventListener('resize', sendHeight);
    if ('ResizeObserver' in window) {
        const ro = new ResizeObserver(sendHeight);
        ro.observe(container);
    } else {
        const mo = new MutationObserver(sendHeight);
        mo.observe(container, {
            childList:     true,
            subtree:       true,
            attributes:    true,
            characterData: true
        });
    }
});*/